import { Token, tokenKey } from '../../@api/Sylius';

export const getCustomerLoods5Id = (): string | undefined => {
    const storedSyliusCustomerToken = localStorage.getItem(tokenKey) || sessionStorage.getItem(tokenKey);

    const tokenData = storedSyliusCustomerToken
        ? JSON.parse(storedSyliusCustomerToken) as Token
        : undefined;

    return tokenData?.customerLoods5Id;
};
